import { Injectable } from "@angular/core";
// import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SupportService {
  constructor(private httpClient: HttpClient) {}

  getSupportList(): Observable<any> {
    const api = " https://nrmapi.azurewebsites.net/api/GetAllSupport";
    return this.httpClient.get(api);
  }

  updateUser(userData): Observable<any> {
    console.log("in put req - update: ", userData);
    const api = "https://nrmapi.azurewebsites.net/api/UpdateDoor";
    return this.httpClient.post(api, userData);
  }
}
